import React from "react";

import { ZplPrintButton } from "../../components";
import HubContextMenuItem from "../../components/HubContextMenu/HubContextMenuItem";

const BarcodePrintMenuItem = ({ getZplString = () => {}, test }) => {
  const PRINT = {
    id: "print",
    label: test ? "Print Test Barcodes" : "Print Barcodes",
    icon: "Printer",
  };

  const MENU_BUTTON = <HubContextMenuItem key="print" item={PRINT} />;
  return (
    <ZplPrintButton
      customMenuButton={MENU_BUTTON}
      getZplString={getZplString}
    />
  );
};

export default BarcodePrintMenuItem;
